<template>
  <div class="bg-card wow fadeInDown">
    <div class="zy-container">
      <slot name="title"></slot>
      <div class="func-title text-center" v-if="funInfo.title">智莺 <span style="color: #353FDC">“{{ funInfo.title }}”</span> 具体有什么内容呢？</div>
      <div class="row">
        <div class="model-content " style="margin-top: 64px">
          <div class="info-title">{{ currentInfo.title }}</div>
          <div class="info-tag"></div>
          <p class="info-desc">{{ currentInfo.text }}</p>
        </div>
        <div class="img ">
          <img :src="currentInfo.img" alt="" style="width: 542px">
        </div>
        <div class="menu-bar " style="margin-top: 10px">
          <el-scrollbar style="height: 420px">
            <div class="menu-widget">
              <div class="menu-item" v-for="(item,index) in funInfo.list" :key="index" :class="{'menu-item-active':index===menuIndex}" @mouseover="onMouseover(index)">
                <div class="menu-col">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from "wowjs";

export default {
  props: {
    funInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    currentInfo() {
      return this.funInfo.list[this.menuIndex]
    }
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  data() {
    return {
      menuIndex: 0
    }
  },
  methods: {
    onMouseover(index) {
      this.menuIndex = index
    }
  }
}
</script>

<style scoped lang="scss">
.bg-card {
  background: #F8F8FC;
  padding-bottom: 85px;
  padding-top: 100px;
}

.row {
  display: flex;
  justify-content: space-between;

  .model-content {
    width: 35%;
  }

  .img {
    width: 40%;
  }

}

.func-title {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  padding-bottom: 100px;
}

.info-title {
  height: 45px;
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  line-height: 45px;
}

.info-tag {
  width: 53px;
  height: 5px;
  background: linear-gradient(137deg, #E266FF 0%, #00FCFF 100%);
  border-radius: 4px;
  margin-bottom: 12px;
  margin-top: 10px;
}

.info-desc {
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  line-height: 40px;
}

.menu-widget {
  width: 252px;

  .menu-col {
    width: 243px;
    height: 86px;
    display: flex;
    align-items: center;
    background: #fff;
    margin-bottom: 24px;
    text-align: center;
    cursor: pointer;
    justify-content: center;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    color: #333333;
    margin-left: 9px;
  }

  .menu-item-active {
    background-image: url(../../../assets/images/index/card-bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .menu-col {
      color: #fff;
      background: none !important;
    }
  }
}


</style>
